'use strict';

angular.module('accessRequestModule')
    .factory('AccessRequest', function (DS)
    {
        return DS.defineResource({
            basePath: '/api/',
            name: 'AccessRequest',
            endpoint: 'access-requests',
            upsert: true
        });
    });


